export default "__VITE_ASSET__f2bd6875__"